import SourceCategoryPage from 'SourceRoute/CategoryPage/CategoryPage.component';
import CategoryProductList from 'Component/CategoryProductList';
import CategorySeo from 'Component/CategorySeo';
import ContentWrapper from 'Component/ContentWrapper';

export class CategoryPage extends SourceCategoryPage {
    renderCategoryProductList() { // added <CategorySeo />
        const {
            filter,
            search,
            selectedSort,
            selectedFilters,
            isMatchingListFilter,
            isCurrentCategoryLoaded,
            category
        } = this.props;

        return (
            <div block="CategoryPage" elem="ProductListWrapper">
                { this.renderItemsCount(true) }
                <CategoryProductList
                  filter={ filter }
                  search={ search }
                  sort={ selectedSort }
                  selectedFilters={ selectedFilters }
                  isMatchingListFilter={ isMatchingListFilter }
                  isCurrentCategoryLoaded={ isCurrentCategoryLoaded }
                  category = { category }
                />
                <CategorySeo />
            </div>
        );
    }

    renderContent() {
        return (
            <>
                <div block="CategoryPageDescription" elem="Container" mix={ { block: 'CategoryPage', elem: 'Miscellaneous' } }>
                    { this.renderCategoryDetails() }
                    { this.renderCategorySort() }
                    { this.renderFilterButton() }
                </div>
                <div block="CategoryPage" elem="ProductListContainer">
                    { this.renderFilterOverlay() }
                    { this.renderCategoryProductList() }
                </div>
            </>
        );
    }

    render() {
        return (
            <main block="CategoryPage">
                <ContentWrapper
                  wrapperMix={ { block: 'CategoryPage', elem: 'Wrapper' } }
                  label="Category page"
                >
                    { this.renderContent() }
                </ContentWrapper>
            </main>
        );
    }
}

export default CategoryPage;
